angular.module('leanlaw').directive('timer', ['userService', '$rootScope', '$state', 'timerManager', 'entryEditService', 'snippetService', function (userService, $rootScope, $state, timerManager, entryEditService, snippetService) {
  return {
    restrict: 'E',
    scope: {
      timerModel: '=',
      tasks: '='
    },
    template: require('./views/timer.html'),
    link: function ($scope, element, attrs, ctrl) {
      // Whether to show the editing dropdown
      $scope.isEditing = false;
      $scope.activated = false;
      $scope.cmQuery = {
        originating: false,
        involved: false,
        reviewer: false,
        primary: false,
        scopeAccount: $scope.timerModel.account?.id || null,
        status: '',
        archived: false
      };
      var editEvent = 'sidebar-timer-edit';
      var entrySaveEvent = 'planner-entry-saved';
      userService.me().then(me => {
        $scope.me = me;
        $scope.activated = true;
        $scope.useNewTimeEntryModal = (me.features?.timeEntriesTab ?? false) && (me.settings?.enableNewTimeEntry ?? false);
        const enableFlags = me.role === 'operator' || me.permissions?.matters?.autoAssign;
        $scope.cmQuery.involved = !enableFlags;
      });
      $scope.adjust = function adjust(param, value) {
        var originalTE = $scope.timerModel.newTimeElapsed;
        if (param == 'hours') {
          $scope.timerModel.newTimeElapsed += value * 60 * 60 * 1000;
        } else {
          $scope.timerModel.newTimeElapsed += value * 60 * 1000;
        }
        if ($scope.timerModel.newTimeElapsed < 0) return $scope.timerModel.newTimeElapsed = originalTE;
      };

      // Getter/setter methods for model
      // https://docs.angularjs.org/api/ng/directive/ngModel
      // cmd+F "ng-model-options"
      $scope.hours = function (newHours) {
        if (newHours) {
          newHours = parseInt(newHours);
          // Clamp
          newHours = Math.min(newHours, 24);
          newHours = Math.max(newHours, 0);
          if (newHours < 0) return;
          // Setter
          // Remove existing hours
          var te = $scope.timerModel.newTimeElapsed;
          var hours = Math.floor(te / (60 * 60 * 1000));
          $scope.timerModel.newTimeElapsed -= hours * 60 * 60 * 1000;
          // Add new hours
          $scope.timerModel.newTimeElapsed += newHours * 60 * 60 * 1000;
        }
        // Use time string (math is done for us)
        return $scope.timerModel.timeString(true).split(':')[0];
      };
      $scope.minutes = function (newMinutes) {
        if (newMinutes) {
          newMinutes = parseInt(newMinutes);
          // Clamp
          newMinutes = Math.min(newMinutes, 59);
          newMinutes = Math.max(newMinutes, 0);
          if (newMinutes < 0) return;
          // Setter
          // Remove existing minutes
          var te = $scope.timerModel.newTimeElapsed;
          var hours = Math.floor(te / (60 * 60 * 1000));
          //grabs the minutes
          var minutes = Math.floor(te / (60 * 1000)) - hours * 60;
          $scope.timerModel.newTimeElapsed -= minutes * 60 * 1000;
          // Add new minutes
          $scope.timerModel.newTimeElapsed += newMinutes * 60 * 1000;
        }
        // Use time string (math is done for us)
        return $scope.timerModel.timeString(true).split(':')[1];
      };
      $scope.startTime = function () {
        const {
          startTime
        } = $scope.timerModel;
        let date = new Date(startTime);
        // if the startTime is not a timestamp, it is already parsed
        if (!date.getTime() > 0) {
          date = startTime;
        }
        const options = {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
          hour: 'numeric',
          minute: 'numeric'
        };
        return date.toLocaleTimeString('en-US', options);
      };

      // Copy new time to actual timer
      $scope.setNewTime = function () {
        // round off to nearest minute
        $scope.timerModel.timeElapsed = Math.floor($scope.timerModel.newTimeElapsed / (60 * 1000)) * 60 * 1000;
        $scope.timerModel.save();
      };

      // Opposite of setNewTime
      $scope.cancelNewTime = function () {
        $scope.timerModel.newTimeElapsed = $scope.timerModel.timeElapsed;
      };
      $scope.startEditing = function startEditing(event) {
        // Don't edit multiple times
        if ($scope.isEditing) return;
        if ($scope.tasks && Array.isArray($scope.tasks) && $scope.tasks.length > 0) {
          const textareaId = 'timer-description-' + $scope.timerModel.id.toLowerCase();
          snippetService.addShortCodeHandler(textareaId, $scope.tasks);
        }
        $rootScope.$broadcast(editEvent, $scope.timerModel);
        $scope.isEditing = true;
      };
      $scope.stopEditing = function stopEditing() {
        $scope.isEditing = false;
      };
      $scope.deleteTimer = function deleteTimer() {
        $scope.timerModel.delete();
      };
      $scope.saveTimer = function saveTimer() {
        const hours = entryEditService.roundToCeilStep($scope.timerModel.getElapsedHours());

        // Check if new time entry modal should be used
        if ($scope.useNewTimeEntryModal) {
          // Use the new Vue modal for time entry
          $state.go('timeplanner.new2', {
            entry: {
              startTime: $scope.timerModel.startTime,
              client: $scope.timerModel.client,
              matter: $scope.timerModel.matter,
              hours: +hours,
              description: $scope.timerModel.description,
              account: $scope.$parent.plannerAccount
            },
            timerId: $scope.timerModel.id
          });
        } else {
          // Use the traditional modal
          $state.go('timeplanner.new', {
            entry: {
              startTime: $scope.timerModel.startTime,
              client: $scope.timerModel.client,
              matter: $scope.timerModel.matter,
              // TODO: Allow rounding to quarter-hours if supported
              hours: +hours,
              description: $scope.timerModel.description,
              account: $scope.$parent.plannerAccount
            },
            expanded: !$scope.$parent.singleDayView,
            timerId: $scope.timerModel.id
          });
        }
      };

      // Debounced function
      var debouncedSave = _.debounce(function saveFunction() {
        $scope.timerModel.save();
      }, 1000);

      // Save timer only occasionally
      $scope.$watch('timerModel.matter', function (newValue) {
        // Save when matter is set
        if ($scope.isEditing) {
          $scope.timerModel.save();
        }
      });

      // Save timer only after user has stopped editing
      $scope.handleDescriptionChange = function (newValue) {
        debouncedSave();
      };

      // Hide editor when other timers are clicked
      $rootScope.$on(editEvent, function (event, model) {
        // Don't listen to our own events
        if (model === $scope.timerModel) return;

        // Close editor
        $scope.isEditing = false;
      });

      // Clear the timer after the user has saved the entry
      $rootScope.$on(entrySaveEvent, function (event, timerId, entry, keepTimer) {
        if (timerId !== $scope.timerModel.id) return;
        if (keepTimer) {
          timerManager.createNewTimerInPlaceFor(timerId, entry);
        }
        $scope.deleteTimer();
      });
    }
  };
}]);